// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"291":"3a8e5a99","566":"8695f453","594":"e009d602","927":"7f24f0fe"}[chunkId] + ".chunk.css";
};